import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import { TransfersData } from "src/types/products";

import Context from "../context";

const useGetTransferPositions = () => {
	const { state } = useContext(Context);

	const { data: positionsData } = useQuery<TransfersData>({
		queryKey: ["transfers", "assets", state.connectionToken],
		initialData: {
			activePositions: [],
			status: "READY"
		}
	});

	return {
		positions: positionsData.activePositions
	};
};

export default useGetTransferPositions;
